import React from "react";
import GetInTouchtwo from "./Section/GetinTouchtwo";
import Futurevision from "./Section/Futurevision";
import AboutSolution from "./Section/AboutSolution";
import Aboutimagediv from "./Section/Aboutimagediv";
import { Helmet } from "react-helmet-async";

function Aboutus() {


  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">

      <Helmet>
        <title>AKT : About Us</title>

        <meta name="description" content="AKT Corp works with a concentrated set of leading suppliers bringing the best materials to our client's business needs. AKT Corp recognizes the need to support clients with high-quality products and marketing support." />

        <meta name="keywords" content="AKT Corp, Arabian Karim Trading Co. LLC, AKT Trading, AKT Corporation, Industrial Solutions, Industrial Equipment Suppliers, Building Materials Supplier, Offshore Industry Supplies, Oil & Gas Industry Supplies, Steel Solutions Supplier, Fiber Optics Solutions, Advanced Silicone Products, Industrial Lubricants Supplier, Fire-Rated Components, Thermal Insulation Solutions, Heavy Equipment Supplies, Electronics Industry Materials, Personal Care & Healthcare Solutions, Saudi Aramco Supplier, MARAFIQ Industrial Solutions, Saudi Arabia Railways Co Supplies, Petro Rabigh Industrial Products, Herkula Partner, Livesmart Partner, Momentive Products Supplier, Fenzi Industrial Solutions, Reliable Industrial Supplies, High-Quality Industrial Equipment, Heavy Machinery Lubricants, Advanced Sealing & Adhesives, Manufacturing Materials Supplier, Construction Materials Supplier, Electrical Components Supplier, Industrial Chemicals & Coatings, Request a Quote AKT Corp, Industrial Supplier in Saudi Arabia, Contact AKT Corp, Buy Industrial Materials Online, Fast & Reliable Industrial Supplies, Customized Industrial Solutions" />
      </Helmet>

      <Aboutimagediv />



      <AboutSolution />



      <Futurevision />



      <GetInTouchtwo />

      <div className="lg:col-span-5 bg-white  p-6 mt-4 mb-2 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[300px]">
        <h2 className="text-2xl md:text-4xl font-bold mb-2  text-center text-red">
          Disclaimer
        </h2>
        <p className="text-sm md:text-lg md:mt-1 mb-6 text-justify text-[#0c2340]">
        Despite every effort has been made to provide accurate images of each product color, design, description, and packaging, 
        but actual colors, design, description, and packaging may vary slightly, due to different device screen settings, 
        the lighting in the installation location, slight differences in product finishes over time and other factors. 
        Our company will not accept responsibility for any color or design differences that are not factory faults. 
        In purchasing from our company, you agree to accept the small risk that there will be a slight variation between the actual color, 
        design, size, description, packing, and the representation on our website/catalog.
        </p>
      </div>

    </div>
  );
}

export default Aboutus;
